import styled from "styled-components";

export const OuterContainer = styled.div<{$theme: string; $imageContentModule: boolean; }>`
  h3 {
    padding: 10px 0 25px;
    font-size: 30px;
    line-height: 32px;
    color: ${({ $theme }) => $theme == 'dark' ? '#fff' : '#000'};
  }

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
      h3 {
        margin: 0;
        padding-top: 0;
        padding-bottom: 12px;
        text-transform: uppercase;
        font-family: Futura, sans-serif;
        font-weight: 900;
        font-size: 32px;
        line-height: 40px;

        @media (min-width: 1024px) {
          font-size: 56px;
          line-height: 62px;

        }
      }
  `}
`;

export const Container = styled.div`
  margin-top: 40px;
  margin-bottom: 60px;
`;

export const Entry = styled.div<{$isFirst: boolean; $isLast: boolean; $theme: string; $imageContentModule: boolean; $brand: string; }>`
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .125);
  border-bottom: 0;

  ${({ $isFirst }) => $isFirst && `
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  `}

  ${({ $isLast }) => $isLast && `
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, .125);
  `}

  ${({ $theme }) => $theme == 'dark' && `
    border-color: rgba(155, 155, 155, .2);
  `}

  ${({ $imageContentModule, $isLast }) =>
    $imageContentModule &&
    `
    border: 0;
    box-shadow: none;

    ${!$isLast && `
      border-bottom: 1px solid rgba(0, 0, 0, .125);
    `}
  `}

  ${({ $brand, $isFirst }) =>
    $brand == 'fender' &&
    `
      border: none;
      position: relative;
      line-height: normal;

      &::after {
        content: "";
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: 0;
        height: 1px;
        background: #e5e5e5;
        display: block;
        margin-bottom: 1px;
      }

      ${$isFirst ? `
        &::before {
          content: "";
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0;
          height: 1px;
          background: rgba(0, 0, 0, .125);
          display: block;
        }
      ` : ''}
    `
  }
`;

export const QuestionWrap = styled.div<{$theme: string; $imageContentModule: boolean; $brand: string; $isOpen: boolean;}>`
  padding: 12px 20px;
  box-shadow: 1px 2px 0 #0083ff;
  margin-bottom: -1px;

  ${({ $theme }) => $theme == 'dark' && `
    background-color: #2A2B2E;
  `}

  ${({ $brand }) =>
    $brand == 'fender' &&
    `
      position: relative;
      padding: 0;
      padding-left: 0;
      padding-top: 32px;
      padding-bottom: 23px;
      margin-bottom: 0;
      line-height: normal;
      box-shadow: none;
    `
  }

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
    box-shadow: none;
    padding-top: 25px;
    padding-left: 0;
    padding-right: 0;
  `}
`;

export const Question = styled.h6<{$isOpen: boolean; $theme: string; $imageContentModule: boolean; $brand: string; }>`
  position: relative;
  font-size: 18px;
  line-height: 29px;
  color: ${({ $theme }) => $theme == 'dark' ? '#eaeaea' : '#121212'};
  padding: 8px 0;
  cursor: pointer;
  user-select: none;
  margin: 0;

  &:before, &:after {
    content: "";
    position: absolute;
    top: calc(50% - 1px);
    right: 1rem;
    display: block;
    width: 14px;
    height: 2px;
    background: ${({ $theme }) => $theme == 'dark' ? '#0083ff' : '#333'};
    transition: all 300ms;
  }

  ${({ $isOpen }) => !$isOpen && `
    &:after {
      transform: rotate(90deg);
    }
  `}

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
      font-size: 22px;
      border: none !important;
      padding: 0;
      font-family: Futura, sans-serif;
      text-transform: none !important;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      letter-spacing: normal;
      color: #000;
      margin-bottom: 0 !important;
      background: transparent !important;
  `}

  ${({ $brand }) =>
    $brand == 'fender' &&
    `
      font-size: 16px;
      font-weight: 600;
      padding: 0px;
      padding-right: 32px;

      @media (min-width: 1024px) {
        font-family: Instrument Sans, sans-serif;
        letter-spacing: 0.18px;
        font-size: 18px;
      }
    `
  }
`;

export const Answer = styled.div<{$theme: string; $imageContentModule: boolean; $brand: string; }>`
  padding: 48px;

  p, ul, li {
    color: ${({$theme}) => $theme == 'dark' ? '#eaeaea' : '#3c3c3c'};
    margin-bottom: 0;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: normal;
  }

  ${({ $brand }) =>
    $brand == 'fender' &&
    `
      padding: 0;
      padding-left: 0px;
      padding-right: 20px;
      padding-bottom: 32px;

      p {
        font-size: 14px;
      }
      
      @media (min-width: 1024px) {
      font-size: 16px;
    }
  `}

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
      padding: 0;
      padding-left: 0;
      padding-right: 60px;
      padding-bottom: 20px;
      font-family: Futura, sans-serif;
      font-size: 16px;
      line-height: 26px;
  `}
`;

export const FAQContentWrapper = styled.div<{$imageContentModule: boolean}>`
  display: flex;
  flex-direction: column;

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
    @media (min-width: 768px) {
      flex-direction: row;
      align-items: flex-start;
    }
  `}
`;

export const ImageContainer = styled.div<{$imageContentModule: boolean}>`
  display: ${({ $imageContentModule }) => ($imageContentModule ? "block" : "none")};
  margin-bottom: 24px;
  text-align: center;
  padding-left: 16px;
  padding-right: 16px;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
  }

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
    @media (min-width: 768px) {
      width: 50%;
      margin-bottom: 0;
    }
  `}
`;

export const FAQContent = styled.div<{$imageContentModule: boolean}>`
  flex: 1;

  ${({ $imageContentModule }) =>
    $imageContentModule &&
    `
    @media (min-width: 768px) {
      padding-left: 24px;
    }
  `}
`;